export function parseListingDisplayPrice(displayPrice: string) {
  try {
    /* Ensure there is not just a period, but a period surrounded by numbers to cover AED currency. */
    const [displayPriceCentsLess, displayPriceCents] = displayPrice.match(
      /(\d)\.(\d)/,
    )
      ? displayPrice.split(".")
      : [displayPrice, "00"];

    /* Remove all non-digit characters from the string */
    const stringAmount = displayPriceCentsLess.replace(/[^0-9]+/g, "");
    if (!stringAmount)
      throw new Error("Error parsing display price from listing.");

    const amount = Number(stringAmount + displayPriceCents);
    return amount;
  } catch (error) {
    throw error;
  }
}
